import { isPlainObject } from 'lodash-es';

export function isRecord(value: unknown): value is Record<string, unknown> {
    return isPlainObject(value);
}

export function isStringOrNumber(value: unknown): value is string | number {
    return typeof value === 'string' || typeof value === 'number';
}

export function isNonNullable<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
}
